var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-menu",
        {
          staticClass: "el-menu-demo",
          attrs: { "default-active": _vm.activeIndex, mode: "horizontal" },
          on: {
            select: function($event) {
              return _vm.handover($event)
            }
          }
        },
        [
          _c("el-menu-item", { attrs: { index: "documentTypeList" } }, [
            _vm._v("文档类型")
          ]),
          _c("el-menu-item", { attrs: { index: "writeDocument" } }, [
            _vm._v("写入文档")
          ]),
          _c("el-menu-item", { attrs: { index: "documentVersion" } }, [
            _vm._v("文档版本")
          ]),
          _c("el-menu-item", { attrs: { index: "recallTest" } }, [
            _vm._v("召回测试")
          ])
        ],
        1
      ),
      _c("documentTypeList", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "documentTypeList",
            expression: "activeIndex == 'documentTypeList'"
          }
        ],
        ref: "documentTypeList"
      }),
      _c("writeDocument", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "writeDocument",
            expression: "activeIndex == 'writeDocument'"
          }
        ],
        ref: "writeDocument"
      }),
      _c("documentVersion", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "documentVersion",
            expression: "activeIndex == 'documentVersion'"
          }
        ],
        ref: "documentVersion"
      }),
      _c("recallTest", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.activeIndex == "recallTest",
            expression: "activeIndex == 'recallTest'"
          }
        ],
        ref: "recallTest"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }